import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { DeleteFlowContributorDto } from '@/types/dtos/flows/request/delete-flow-contributor.dto';
import { GET_EVENT_FLOWS_QUERY_KEY } from '@/state/queries/flows/use-get-event-flows';
import { GET_FLOW_QUERY_KEY } from '@/state/queries/flows/use-get-flow';
import { GET_EVENT_CONTRIBUTORS_QUERY_KEY } from '@/state/queries/contributors/use-get-event-contributors';
import { invalidatePublicationStateQueries } from '@/state/queries/events/use-publication-state';

export const useDeleteFlowContributor = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: DeleteFlowContributorDto) => {
      const token = await getToken();
      return deleteFlowContributor(params, token ?? '');
    },
    onSuccess: (_, variables) => {
      return Promise.all([
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_FLOWS_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_FLOW_QUERY_KEY, variables.flowId],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_CONTRIBUTORS_QUERY_KEY],
        }),
        invalidatePublicationStateQueries(queryClient),
      ]);
    },
  });
};

const deleteFlowContributor = async (data: DeleteFlowContributorDto, token: string) => {
  const url = `${import.meta.env.VITE_API_URL}/flows/${data.flowId}/contributors/${data.contributorId}`;
  return sendJSONRequest({ url, method: METHOD.DELETE, token });
};
